<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import type { PublicCourseTerm } from "@core/schema/CourseTerm.js";
	import { courseTypeNameMap } from "@core/schema/names/courseTypeNameMap.js";
	import { formatPrice } from "@core/utils/formatPrice.js";
	import { toDateTimeMonthYearFormat } from "@core/utils/toDateTimeMonthYearFormat.js";
	import { Cart } from "../../cart/Cart.svelte.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { term }: { term: PublicCourseTerm } = $props();

	const { tenant } = getGlobalTemplateProps();

	const price = $derived(
		formatPrice(Cart.courseOrderPrice.withTax, Cart.currency ?? tenant.defaultCurrency, tenant.locale, true),
	);
</script>

<div class="flex p-6 gap-4 bg-fcrlightgray-200 border border-fcrlightgray-300 rounded-3xl mb-1">
	<div class="flex flex-col gap-1 font-medium">
		<div class="text-lg/6 font-antipol">
			<Formatted text={courseTypeNameMap[term.courseType][tenant.locale]} />
		</div>
		<div class="text-fcrgray mb-3">
			{toDateTimeMonthYearFormat(term.startsAt, tenant.locale)} –
			<Link href={term.placeUrl} target="_blank" rel="noopener noreferrer" class="underline">
				{term.placeName}
			</Link>
		</div>
		<div class="font-antipol">
			<Formatted text={price} />
		</div>
	</div>
</div>
